var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var addRoomModal = require('../../../../locations/addRoomModal');
var gridEquipmentNode = require('./helpers/gridEquipmentNode');
var resizableEquipment = require('./helpers/resizableEquipment');
var svgGridSizing = require('./helpers/svgGridSizing');
const $ = go.GraphObject.make;  // for more concise visual tree definitions
const portCoverBrush = $(go.Brush, "Linear", { 0: "#2a2a2a", 1: "#f0f0f0", start: go.Spot.Bottom, end: go.Spot.Top });
const roomGridDefaults = { cols: 90, rows: 20 };

function getRoomDiagramSvgConverted(data) {
  const svgConverted = data && data.diagramSvgConverted;
  return typeof svgConverted === "string" ? svgConverted : "";
}

function hasRoomDiagramSvg(data) {
  return getRoomDiagramSvgConverted(data).trim().length > 0;
}

function getRoomGridDefaults(data) {
  if (hasRoomDiagramSvg(data)) {
    return svgGridSizing.getGridDefaultsForSvg(getRoomDiagramSvgConverted(data), roomGridDefaults);
  }
  return roomGridDefaults;
}

function getRoomBodySize(data) {
  return gridEquipmentNode.getBodySize(data, getRoomGridDefaults(data));
}

function createRoomBodySizeBinding() {
  return new go.Binding("desiredSize", "", getRoomBodySize);
}

function createRoomSelectionObjectBinding() {
  return new go.Binding("selectionObjectName", "", function(data) {
    return hasRoomDiagramSvg(data) ? "ROOM_SVG" : "BODY";
  });
}

function getRoomGridSize(data) {
  return gridEquipmentNode.getGridSize(data, getRoomGridDefaults(data));
}

function normalizeRoomPortId(portId) {
  if (portId === undefined || portId === null) return "";
  const parts = portId.toString().split("_");
  return parts.length > 1 ? parts[1] : parts[0];
}

function getPortArray(nodeData, arrayName) {
  return nodeData && Array.isArray(nodeData[arrayName]) ? nodeData[arrayName] : [];
}

function getBoundPortArray(itemPanel, arrayName) {
  if (itemPanel && itemPanel.panel && Array.isArray(itemPanel.panel.itemArray)) {
    return itemPanel.panel.itemArray;
  }
  const nodeData = itemPanel && itemPanel.part && itemPanel.part.data;
  return getPortArray(nodeData, arrayName);
}

function getItemIndex(portData, itemPanel, arrayName) {
  const ports = getBoundPortArray(itemPanel, arrayName);
  const arrayIndex = ports.indexOf(portData);
  if (arrayIndex >= 0) return arrayIndex;
  return Math.max(Number(itemPanel && itemPanel.itemIndex) || 0, 0);
}

function getPortCellIndex(itemIndex, portCount, cellCount) {
  const count = Math.max(Number(portCount) || 0, 1);
  const gridCells = Math.max(Math.round(Number(cellCount) || 0), 1);
  const gap = count > 1 && (1 + ((count - 1) * 2)) <= gridCells ? 2 : 1;
  const occupiedCells = 1 + ((count - 1) * gap);
  const start = Math.max(Math.floor((gridCells - occupiedCells) / 2), 0);
  return Math.max(0, Math.min(gridCells - 1, start + (itemIndex * gap)));
}

function getPortCellCenterOffset(itemIndex, portCount, cellCount, cellSize) {
  return (getPortCellIndex(itemIndex, portCount, cellCount) + 0.5) * cellSize;
}

function getCenterCellOffset(cellCount, cellSize) {
  const gridCells = Math.max(Math.round(Number(cellCount) || 0), 1);
  return (Math.floor((gridCells - 1) / 2) + 0.5) * cellSize;
}

function createRoomPortAlignmentBinding(side, arrayName) {
  return new go.Binding("alignment", "", function(portData, itemPanel) {
    const nodeData = itemPanel && itemPanel.part && itemPanel.part.data;
    const gridSize = getRoomGridSize(nodeData);
    const ports = getBoundPortArray(itemPanel, arrayName);
    const itemIndex = getItemIndex(portData, itemPanel, arrayName);
    const cellSize = gridEquipmentNode.getResizeCellSize();

    if (side === "center") {
      const xOffset = getPortCellCenterOffset(itemIndex, ports.length, gridSize.cols, cellSize.width);
      return new go.Spot(0, 0, xOffset, getCenterCellOffset(gridSize.rows, cellSize.height));
    }

    if (side === "left" || side === "right") {
      const yOffset = getPortCellCenterOffset(itemIndex, ports.length, gridSize.rows, cellSize.height);
      return new go.Spot(side === "left" ? 0 : 1, 0, 0, yOffset);
    }

    const xOffset = getPortCellCenterOffset(itemIndex, ports.length, gridSize.cols, cellSize.width);
    return new go.Spot(0, side === "top" ? 0 : 1, xOffset, 0);
  });
}

function getRoomPortLinkSpot(side) {
  if (side === "left") return go.Spot.Left;
  if (side === "right") return go.Spot.Right;
  if (side === "top") return go.Spot.Top;
  if (side === "bottom") return go.Spot.Bottom;
  return go.Spot.AllSides;
}

function createPortFillBinding() {
  return new go.Binding("fill", "portColor", function(portColor) {
    if (!edit.vm.editing()) {
      return portCoverBrush;
    } else {
      return portColor;
    }
  });
}

function createSvgDataUrl(svgConverted) {
  const svg = typeof svgConverted === "string" ? svgConverted.trim() : "";
  if (!svg) return "";
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

function createRoomSvgPanel() {
  return $(go.Picture,
    {
      name: "ROOM_SVG",
      stretch: go.GraphObject.Fill,
      alignment: go.Spot.Center,
      imageStretch: go.ImageStretch.Fill,
      pickable: false,
      isActionable: false
    },
    new go.Binding("visible", "", hasRoomDiagramSvg),
    new go.Binding("source", "", function(data) {
      return createSvgDataUrl(getRoomDiagramSvgConverted(data));
    })
  );
}

function createRoomSpotPortItemTemplate(side, arrayName, isCenterPort) {
  const cellSize = gridEquipmentNode.getResizeCellSize();
  const linkSpot = getRoomPortLinkSpot(side);
  const linkableBindings = isCenterPort ? [
    new go.Binding("visible", "", function() {
      return edit.vm.editing() ? true : false;
    }),
    new go.Binding("fromLinkable", "", function() {
      return true;
    }),
    new go.Binding("toLinkable", "", function() {
      return true;
    }),
    new go.Binding("fromMaxLinks", "", function() {
      return 1;
    }),
    new go.Binding("toMaxLinks", "", function() {
      return 1;
    })
  ] : [
    new go.Binding("fromLinkable", "type", function(type) {
      return type === "output";
    }),
    new go.Binding("toLinkable", "type", function(type) {
      return type === "input";
    })
  ];

  return $(go.Panel, "Spot",
    {
      alignmentFocus: go.Spot.Center
    },
    createRoomPortAlignmentBinding(side, arrayName),
    $(go.Shape, "Rectangle",
      {
        _side: side,
        fromSpot: linkSpot,
        toSpot: linkSpot,
        cursor: "pointer",
        stroke: null,
        strokeWidth: 0,
        desiredSize: cellSize
      },
      ...linkableBindings,
      new go.Binding("portId", "portId", normalizeRoomPortId),
      createPortFillBinding()
    )
  );
}

function createRoomSpotPortPanel(arrayName, side, isCenterPort) {
  return $(go.Panel, "Spot",
    {
      alignment: go.Spot.Center,
      alignmentFocus: go.Spot.Center,
      isActionable: false,
      itemTemplate: createRoomSpotPortItemTemplate(side, arrayName, isCenterPort === true)
    },
    new go.Binding("itemArray", arrayName),
    $(go.Shape, "Rectangle",
      {
        isPanelMain: true,
        fill: null,
        stroke: null,
      },
      createRoomBodySizeBinding()
    )
  );
}

function createLocationNodeTemplate(map, useGeoPositioning, submitCallback) {
  return $(go.Node, "Spot",
  {
    locationSpot: go.Spot.TopLeft,
    locationObjectName: "BODY",
    selectionObjectName: "BODY",
    selectionAdornmentTemplate: gridEquipmentNode.createSelectionAdornmentTemplate(),
    resizeObjectName: "BODY",
    resizeCellSize: gridEquipmentNode.getResizeCellSize(),
    layerName: "Background",
    contextMenu: edit.vm.editing() ? $("ContextMenu",
      $("ContextMenuButton",
        $(go.TextBlock, "Edit Room"),
        { 
          click: (e, obj) => {
            addRoomModal.editDialogue(obj.part.data.roomRecord, obj.part.data.parentLocation, { submitCallback: submitCallback })
            m.redraw();
          }
        }
      ),
      $("ContextMenuButton",
        $(go.TextBlock, "Edit Permissions"),
        { 
          click: (e, obj) => {
            m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}/permissions`)
          }
        }
      )
    ) : null,
  },
  new go.Binding("cursor", "", data => {
    return edit.vm.editing() ? "pointer" : "default";
  }),
  new go.Binding("deletable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("selectable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("movable", "", data => {
    return edit.vm.editing();
  }),
  createRoomSelectionObjectBinding(),
  resizableEquipment.createResizableBinding(),
  useGeoPositioning ? 
    new go.Binding("location", "latlong", data => {
      const pos = map.project(data, map.getZoom());
      return new go.Point(pos.x, pos.y);
    }).makeTwoWay((pt, data) => {
      if (updatingGoJs) {
        return data.latlong; // no-op
      } else {
        const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
        return [ll.lat, ll.lng];
      }
    })
  : 
    new go.Binding("location", "latlong", data => {
      return new go.Point(data[0], data[1]);
    }),
  $(go.Panel, "Spot",
    {
      name: "BODY",
      isPanelMain: true
    },
    createRoomBodySizeBinding(),
    $(go.Shape, "Rectangle",
      {
        name: "ROOM_BODY_BORDER",
        isPanelMain: true,
        fill: 'transparent',
        stroke: "#888888",
        strokeWidth: 2,
        stretch: go.GraphObject.Fill
      },
      new go.Binding("stroke", "", function(data) {
        return hasRoomDiagramSvg(data) ? null : "#888888";
      })),
    createRoomSvgPanel()
  ),
  createRoomSpotPortPanel("leftArray", "left"),
  createRoomSpotPortPanel("topArray", "top"),
  createRoomSpotPortPanel("rightArray", "right"),
  createRoomSpotPortPanel("bottomArray", "bottom"),
  createRoomSpotPortPanel("centerArray", "center", true)
);  
}

module.exports = createLocationNodeTemplate;
